const icons = {
  arrow_left: 'https://cdn.shopify.com/s/files/1/0851/3044/5066/files/Arrow_Left.svg?v=1743080400',
  arrow_right: 'https://cdn.shopify.com/s/files/1/0851/3044/5066/files/Arrow_Right.svg?v=1743080400',
  chevron_left: 'https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Left.png?v=1737122129',
  chevron_right: 'https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Right.png?v=1737122129'
};
const buttons = {
  prevArrow: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${icons.arrow_left}' alt='arrow'/></button>`,
  nextArrow: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${icons.arrow_right}' alt='arrow'/></button>`
}


$(document).ready(function () {
  // Collection Sort & Filter Functionality
  function initCollection() {
    const $elements = {
      button: $('.moerie-collection__sort-button'),
      dropdown: $('.moerie-collection__sort-dropdown'),
      options: $('.moerie-collection__sort-option'),
      container: $('.moerie-collection'),
      products: $('.moerie-collection__product'),
      tabs: $('.moerie-collection__header-tab')
    };

    if ($elements.button.length) initSort($elements);
    if ($elements.tabs.length) initFilter($elements);
  }

  function initSort($elements) {
    // Close dropdown on outside click
    $(document).on('click', e => {
      if (!$(e.target).closest('.moerie-collection__product-sort').length) {
        $elements.button.removeClass('active');
        $elements.dropdown.removeClass('active');
      }
    });

    // Toggle dropdown
    $elements.button.on('click', e => {
      e.preventDefault();
      $elements.button.toggleClass('active');
      $elements.dropdown.toggleClass('active');
    });

    // Handle sort option selection
    $elements.options.on('click', function () {
      const value = $(this).data('value');
      const text = $(this).text();

      updateSortUI($elements, text);
      fetchSortedCollection($elements, value);
    });

    // Set initial active option
    const currentSort = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
    const currentOption = $elements.options.filter(`[data-value="${currentSort}"]`);
    if (currentOption.length) {
      currentOption.addClass('active');
      $elements.button.find('span').text(currentOption.text());
    }
  }

  function initFilter($elements) {
    // Handle tab selection
    $elements.tabs.on('click', function () {
      const value = $(this).data('value');

      // Update active state
      $elements.tabs.removeClass('active');
      $(this).addClass('active');

      // Filter products with animation
      if (value === 'all') {
        $elements.products.fadeIn(300, () => reinitializeSlick($elements.container));
      } else {
        $elements.products.not(`[data-value="${value}"]`).fadeOut(300);
        $elements.products.filter(`[data-value="${value}"]`).fadeIn(300, () => reinitializeSlick($elements.container));
      }
    });

    // Set initial active tab
    $elements.tabs.filter('[data-value="all"]').addClass('active');
  }

  function reinitializeSlick($container) {
    // Destroy existing slick instances first
    const $sliders = $container.find('.pr-item__product-images.gallery-slider');
    if ($sliders.hasClass('slick-initialized')) {
      $sliders.slick('unslick');
    }

    // Initialize slick carousel
    $sliders.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: buttons.prevArrow,
      nextArrow: buttons.nextArrow,
    });
  }

  function updateSortUI($elements, text) {
    $elements.button.find('span').text(text);
    $elements.options.removeClass('active');
    $elements.options.filter(`:contains("${text}")`).addClass('active');
    $elements.button.removeClass('active');
    $elements.dropdown.removeClass('active');
  }

  function fetchSortedCollection($elements, sortValue) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    window.history.pushState({}, '', url.toString());

    $elements.container.css('opacity', '0.5');

    $.ajax({
      url: url.toString(),
      method: 'GET',
      success: response => {
        const newContent = $(response).find('.moerie-collection').html();
        $elements.container.html(newContent);

        // Update elements reference after content refresh
        $elements.products = $('.moerie-collection__product');

        // Reinitialize slick carousel
        reinitializeSlick($elements.container);

        // Reapply current filter if any
        const activeTab = $('.moerie-collection__header-tab.active');
        if (activeTab.length && activeTab.data('value') !== 'all') {
          $elements.products.hide();
          $elements.products.filter(`[data-value="${activeTab.data('value')}"]`).fadeIn(300);
        }

        $elements.container.css('opacity', '1');
        $(document).trigger('collection:updated');
      },
      error: () => window.location.href = url.toString()
    });
  }

  // Initialize if elements exist
  if ($('.moerie-collection__sort-button, .moerie-collection__header-tab').length) {
    initCollection();
  }
});